/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePageManageTicket } from '../../models/api-response-page-manage-ticket';
import { ManageTicketSearchReq } from '../../models/manage-ticket-search-req';

export interface SearchManageTicket$Params {
  requestId: string;
  canal: string;
      body: ManageTicketSearchReq
}

export function searchManageTicket(http: HttpClient, rootUrl: string, params: SearchManageTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePageManageTicket>> {
  const rb = new RequestBuilder(rootUrl, searchManageTicket.PATH, 'post');
  if (params) {
    rb.query('requestId', params.requestId, {});
    rb.query('canal', params.canal, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePageManageTicket>;
    })
  );
}

searchManageTicket.PATH = '/v1/api/ui/manage-ticket/search';
